@let displayData = displayData$ | async;

<ul
  #list
  class="list"
  [class.wrap]="displayData?.wrap"
  (click)="useExternalClickAction ? externalClickAction($event, '', list) : null"
>
  @for (val of displayData?.tags ?? []; track val; let i = $index) {
    @let tooltip = (tooltipHeader ? `${tooltipHeader}\n` : '') + String(val);
    <li
      #tag
      class="tag"
      [ngStyle]="val | stylesForTag: palette"
      [blazeTooltip]="tooltip"
      [matTooltipTouchGestures]="'off'"
      matTooltipClass="whitespace-pre-wrap"
      [class.cursor-pointer]="useExternalValueClickAction"
      (click)="valueClick($event, val, tag, i)"
    >
      <span class="text">{{ val }}</span>
      @if (useExternalClickAction) {
        <button class="remove-button" (click)="removeTag($event, val)">
          <mat-icon svgIcon="icon_close_16" />
        </button>
      }
    </li>
  }
</ul>

<div class="actions">
  @if (displayData?.hiddenTagsTooltip) {
    <a
      class="more-button"
      (click)="preventAction($event)"
      [blazeTooltip]="displayData?.hiddenTagsTooltip"
    >
      <button
        blazeIconButton="bat-action"
        [blazeIconButtonActive]="isMenuOpen"
        #menuTrigger
        [matMenuTriggerFor]="menu"
      >
        <mat-icon svgIcon="icon_more_h_24" />
      </button>
    </a>
  }
  @if (canAddValue) {
    <a class="add-button">
      <button blazeIconButton="bat-action">
        <mat-icon svgIcon="icon_add_32" />
      </button>
      <span>Click to select option</span>
    </a>
  }
</div>

<mat-menu #menu class="bd-menu tag-menu tooltips-with-theme">
  <ng-template matMenuContent>
    @for (tag of $any(value); track tag; let i = $index) {
      <ng-container
        [ngTemplateOutlet]="dropdownFilesListTpl"
        [ngTemplateOutletContext]="{ $implicit: tag, index: i }"
      />
    }
  </ng-template>
</mat-menu>

<ng-template #dropdownFilesListTpl let-tag let-index="index">
  <div
    #element
    class="tag-option"
    [ngStyle]="{ backgroundColor: cellStyles?.cellBackground }"
    (mouseover)="element.style.backgroundColor = cellStyles?.cellHoverBackground || ''"
    (mouseout)="element.style.backgroundColor = cellStyles?.cellBackground || ''"
  >
    <div
      class="tag-element"
      [ngStyle]="tag | stylesForTag: palette"
      [blazeTooltip]="tag"
      (click)="useExternalValueClickAction ? valueClick($event, tag, element, index) : null"
    >
      <span class="text">{{ tag }}</span>
      @if (useExternalClickAction) {
        <button
          class="remove-button"
          (click)="useExternalClickAction ? removeTag($event, tag) : null"
        >
          <mat-icon svgIcon="icon_close_16" />
        </button>
      }
    </div>
  </div>
</ng-template>

<span #placeholderTag class="tag placeholder">
  <span class="text"></span>
  @if (useExternalClickAction) {
    <button class="remove-button">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  }
</span>
